import { render } from "./the-sidebar.vue?vue&type=template&id=294ad136&scoped=true"
import script from "./the-sidebar.vue?vue&type=script&lang=js"
export * from "./the-sidebar.vue?vue&type=script&lang=js"

import "./the-sidebar.vue?vue&type=style&index=0&id=294ad136&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-294ad136"]])

export default __exports__